import {ele} from '../../../helper/gen'
import router from '../../../router'
import auth from '../auth/auth'
import gen from '../gen'
const state ={
  isbottomMenuOpen: false,
  isModeSwipe: false,
  showOverlay: false,
  fetchLocLoader: false,
  toggleForAddToWishlist: false,
  imageDetParticular: {},
  swichModesBG: false,
}
const getters = {
  swichModesBG: state => state.swichModesBG,
  imageDetParticular: state => state.imageDetParticular,
  toggleForAddToWishlist: state => state.toggleForAddToWishlist,
  fetchLocLoader: state => state.fetchLocLoader,
  showOverlay: state => state.showOverlay,
  isbottomMenuOpen: state => state.isbottomMenuOpen,
  isModeSwipe: state => state.isModeSwipe
}
const mutations = {
  addToWishlish() {
    if(auth.state.isLoggedIn) {

      console.log('state.imageDetParticular=>', state.imageDetParticular)
      let caption = state.imageDetParticular.caption === ''? 'n': state.imageDetParticular.caption
      let id = state.imageDetParticular.id === undefined?state.imageDetParticular.photoId: state.imageDetParticular.id
      localStorage.setItem('openDirections', JSON.stringify(true))
      router.push(`/id/${id}?inapp=true`)
      setTimeout(()=> {
        state.toggleForAddToWishlist = !state.toggleForAddToWishlist
      }, 50)

    }
    else {
      gen.mutations.snackbar_alert(state,{msg: 'Please sign in to complete your desired action'})
      window.thisOfApp.$modal.hide('ask-to-add-to-wishlist')
      router.push(`/login`)
    }
  },
  fadeOpen(state2) {
    console.log(ele(`bottom-menu`))
    if (state.isbottomMenuOpen) {
      setTimeout(() => {
        ele(`bottom-menu`).style.opacity = 1
      }, 300)
    }
  }
}
export default {
  state,
  getters,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/common/common.js